// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FizzBuzz from "./codeChallenge/fizzBuzz/FizzBuzz.bs.js";
import * as FileSizeCalculation from "./codeChallenge/fileSizeCalculation/FileSizeCalculation.bs.js";

import '../../input.css'
;

function Challenge(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement(FizzBuzz.make, {}), React.createElement(FileSizeCalculation.make, {}));
}

var make = Challenge;

export {
  make ,
}
/*  Not a pure module */
